exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dialog-content .dialog-main[data-v-12f89fd6] {\n  width: 8.306667rem;\n  height: 9.24rem;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 100%;\n}\n.dialog-content .dialog-main .main-value[data-v-12f89fd6] {\n  font-size: 1.146667rem;\n  color: #F13C24;\n  font-weight: 600;\n  text-align: center;\n  padding-top: 5.653333rem;\n}\n.dialog-content .dialog-footer[data-v-12f89fd6] {\n  margin-top: 0.386667rem;\n  text-align: center;\n}\n.dialog-content .dialog-footer .footer-btn[data-v-12f89fd6] {\n  color: #fff;\n  text-decoration: underline;\n}", ""]);

// exports
